import { CustomRadio } from '../../lib/CustomRadio';
import en from '../../lang/en-us';
import { ALL_HOLDINGS, NON_ZERO_HOLDINGS, ZERO_HOLDINGS } from '../../utils/constants';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
const { common } = en;

const labelFor = (value: string) => {
    if (value === ALL_HOLDINGS) return common.HoldingType.allHoldings;
    if (value === ZERO_HOLDINGS) return common.HoldingType.zeroHoldings;
    if (value === NON_ZERO_HOLDINGS) return common.HoldingType.nonZeroHoldings;
    return '';
};

export default function HoldingTypeRadio(props: any) {
    const { selectedValue, handleRadioChange, ...rest } = props;
    const [announcement, setAnnouncement] = useState<string>('');
    const isFirstRender = useRef<boolean>(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        const label = labelFor(selectedValue);
        if (!label) return;
        setAnnouncement('');
        const id = window.setTimeout(() => {
            setAnnouncement(`Showing ${label}`);
        }, 50);
        return () => window.clearTimeout(id);
    }, [selectedValue]);

    return (
        <div className="holding-type-radio">
            <div
                className="sr-only"
                role="status"
                aria-live="assertive"
                aria-atomic="true"
            >
                {announcement}
            </div>
            <div className="desktop_mode">
                <CustomRadio
                    title={
                        <>
                            <img src="/images/filters.svg" alt="" />
                            {common.HoldingType.title}
                            <span className="sr-only">
                                {' '}
                                Changing this option will update the holdings list below.
                            </span>
                        </>
                    }
                    name="holding-type"
                    list={[
                        {
                            label: common.HoldingType.allHoldings,
                            value: ALL_HOLDINGS,
                        },
                        {
                            label: common.HoldingType.zeroHoldings,
                            value: ZERO_HOLDINGS,
                        },
                        {
                            label: common.HoldingType.nonZeroHoldings,
                            value: NON_ZERO_HOLDINGS,
                        },
                    ]}
                    selectedValue={selectedValue}
                    handleRadioChange={handleRadioChange}
                    {...rest}
                />
            </div>
            <div className="mobile_mode">
                <FormControl variant="filled">
                    <InputLabel id="holding-type-mobile">
                        {common.HoldingType.title}
                        <span className="sr-only">
                            {' '}
                            Changing this option will update the holdings list below.
                        </span>
                    </InputLabel>
                    <Select
                        labelId="holding-type-mobile"
                        id="holding-type-dropdown"
                        value={selectedValue}
                        onChange={(e: any) => handleRadioChange(e.target.value)}
                    >
                        <MenuItem value={ALL_HOLDINGS}>{common.HoldingType.allHoldings}</MenuItem>
                        <MenuItem value={ZERO_HOLDINGS}>{common.HoldingType.zeroHoldings}</MenuItem>
                        <MenuItem value={NON_ZERO_HOLDINGS}>
                            {common.HoldingType.nonZeroHoldings}
                        </MenuItem>
                    </Select>
                </FormControl>
            </div>
        </div>
    );
}
